import { api } from '~/plugins/materials-api'
import { useAuthStore } from '~/stores/auth'

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.layout === 'logged-out-fullscreen') {
    return null
  }

  const authStore = useAuthStore()

  if (authStore.isAuthenticated) {
    return null
  }

  try {
    const user = await api.v1.users.me.get()

    authStore.setUser(user)
  }
  catch {
    return navigateTo({ name: 'login', query: { next: to.fullPath } })
  }

  return null
})
